<template>
  <span class="w-5 h-5 inline-flex items-center justify-center" :title="status">
    <i v-if="state === 'paid'" class="pi pi-check text-blueGray-900"></i>
    <i v-else-if="state === 'failed'" class="pi pi-times text-red-500"></i>
    <span v-else class="w-3 h-3 rounded-full bg-blueGray-300 border border-blueGray-200"></span>
  </span>
</template>

<script>
// Maps a loan/saving/investment installment's raw backend status into one of
// three simple visual states. `paidExtra` lets savings/investments also treat
// WITHDRAWN as "paid" (an already-paid installment released at plan completion),
// which doesn't apply to loans.
export default {
  props: {
    status: {
      type: String,
      default: ""
    },
    paidExtra: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    state() {
      if (this.status === "PAID" || this.paidExtra.includes(this.status)) {
        return "paid";
      }
      if (this.status === "PENDING") {
        return "pending";
      }
      return "failed";
    }
  }
}
</script>
